"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDON_TYPE = void 0;
// Difference between ADDON_TYPE and ADDON_ENTITY in that ADDON_TYPE is a list of addon types from Addons table in db
// ADDON_ENTITY is reflection of addons which we can set to output versions. For example, we have DURATION addon, which
// can contain one of LONGFORM(which stores in db) options and DURATION doesn't store in Addons table in db, so we need
// separate constant for cases like this(this is happens because of bad architecture of addons
var ADDON_TYPE = {
  BURN_IN_CAPTIONS: 'BURN_IN_CAPTIONS',
  SRT_CAPTIONS: 'SRT_CAPTIONS',
  CHROMA_KEY: 'CHROMA_KEY',
  EXTRA_FOOTAGE: 'EXTRA_FOOTAGE',
  RUSH_EDIT: 'RUSH_EDIT',
  SUPER_RUSH_EDIT: 'SUPER_RUSH_EDIT',
  LONGFORM_SHORT: 'LONGFORM_SHORT',
  LONGFORM_MEDIUM: 'LONGFORM_MEDIUM',
  LONGFORM_LONG: 'LONGFORM_LONG',
  ADDITIONAL_OUTPUT: 'ADDITIONAL_OUTPUT',
  VOICE_OVER_ARTIST: 'VOICE_OVER_ARTIST',
  VOICE_OVER_ARTISTS: 'VOICE_OVER_ARTISTS',
  VOICE_OVER_ARTIST_MAX: 'VOICE_OVER_ARTIST_MAX',
  SUPERSIZE_MY_EDIT: 'SUPERSIZE_MY_EDIT'
};
exports.ADDON_TYPE = ADDON_TYPE;